import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import PropTypes from "prop-types";
import classnames from "classnames"

import {
    Col,
    Container,
    Row,
    UncontrolledTooltip,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavItem,
    Nav,
    TabPane,
    TabContent,
    NavLink
} from "reactstrap";


import TableContainerV1 from "components/Common/TableContainerV1";
import { callgetFileByBatch, callGetAllFileDataCount } from "../../http/auth/signup";
import { formatDateTime } from "common/utility";

const EmpBulkTargetTable = () => {
    const [userList, setUserList] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
    });
    const [status, setStatus] = useState('complete');
    const [searchValue, setSearchValue] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [columnId, setColumnId] = useState("id");
    const [fileCount, setFileCount] = useState(null);
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [sortingOptions, setSortingOptions] = useState({
        column: "id",
        isAsc: false,
        optionalColumn: ["dealer_code", "month", "target"],
    });
    
    const [customActiveTab, setCustomActiveTab] = useState("1")

    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            if (tab == 1) {
                setStatus('complete')
            } else {
                setStatus('error')
            }
            setCustomActiveTab(tab)
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Batch Id',
                accessor: 'batchId',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                }
            },
            {
                Header: 'Uploaded At',
                accessor: 'createdAt',
                filterable: true,
                Cell: (cellProps) => {
                    return formatDateTime(cellProps.value) || 'NA';
                }
            },
            {
                Header: 'Uploaded File',
                accessor: 'filePath',
                filterable: true,
                Cell: (cellProps) => {
                    return TableFileComponent(cellProps.value, downloadExcelFile);
                },
            },
            {
                Header: 'Uploaded By',
                accessor: 'createdBy',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    let name = ''
                    if (rowData?.createdByUser.firstName) {
                        name += rowData?.createdByUser.firstName + ' '
                    }
                    if (rowData?.createdByUser.lastName) {
                        name += rowData?.createdByUser.lastName + ' '
                    }
                    return name
                }
            },
            // {
            //     Header: 'Dealer Name',
            //     accessor: 'dealer',
            //     filterable: true,
            //     Cell: (cellProps) => {
            //         const rowData = cellProps.row.original;
            //         if (rowData?.uploadedForEntity?.entity_name) {
            //             return rowData?.uploadedForEntity?.entity_name
            //         }
            //     }
            // },
            // {
            //     Header: 'Dealer User',
            //     accessor: 'dealerUser',
            //     filterable: true,
            //     Cell: (cellProps) => {
            //         const rowData = cellProps.row.original;
            //         let name = ''
            //         if (rowData?.dealerUser?.firstName) {
            //             name += rowData?.dealerUser.firstName + ' '
            //         }
            //         if (rowData?.dealerUser?.lastName) {
            //             name += rowData?.dealerUser.lastName + ' '
            //         }
            //         return name
            //     }
            // },
            {
                Header: 'Records',
                accessor: 'noOfRecords',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: 'Status',
                accessor: 'status',
                filterable: true,
                Cell: (cellProps) => {
                    if (cellProps.value == 2) {
                        return 'Targets Added';
                    } else if (cellProps.value == 3) {
                        return 'Completed With Error';
                    }
                    return 'Pending';
                }
            },
            {
                Header: 'Action',
                accessor: '',
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionsComponent(rowData);
                }
            },

        ],
        []
    );

    const getUserList = async (body) => {
        const response = await callgetFileByBatch(body);
        if (response.status) {
            setUserList(response.data.data);
            const { totalItems, totalPages, currentPage } = response.data
            setPagination({
                pageIndex: currentPage,
                pageCount: totalPages,
                totalRecords: totalItems,
            })
        } else {
            setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
            setUserList([]);
        }
    }

    useEffect(() => {
        const bodyData = {
            dataType: 'target',
            status,
        }
        getUserList(bodyData);
    }, [status]);

    const getDataCount = async () => {
        const response = await callGetAllFileDataCount({
            dataType: 'target'
        })
        if (response.status) {
            setFileCount(response.data)
        }
    }

    useEffect(() => {
        getDataCount()
    }, [])

    const handlePageChange = (
        page,
        pageSize,
        searchKey,
        columnName = columnId,
        sortingOrder = sortingOrderStatus) => {
        setPageSize(pageSize);
        getUserList({ page, limit: pageSize, searchKey, dataType: 'target', columnName, sortingOrder, status })
    }

    const handleClearSearch = () => {
        setSearchValue("");
        getUserList({ page: 1, searchKey: '', dataType: 'target', status })
    };

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        getUserList({ page: 1, limit: pageSize, searchKey: searchValue, columnName, sortingOrder, status, dataType: 'target', })
    };

    const handleSearchFilter = (value, pageSize) => {
        setSearchValue(value)
        getUserList({ page: 1, searchKey: value, dataType: 'target', limit: pageSize, status })
    }
    return (
        <div>
            <Container fluid >
                <Row className="vertical-scroll">
                    <Col xs="12">
                        <Nav tabs className="nav-tabs-custom nav-justified">
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: customActiveTab === "1",
                                    })}
                                    onClick={() => {
                                        toggleCustom("1")
                                    }}
                                >
                                    <span className="d-block d-sm-none">
                                        <i className="fas fa-home"></i>
                                    </span>
                                    <span className="d-none d-sm-block">
                                        Successfully Uploaded({fileCount?.completedFileCount})
                                    </span>
                                </NavLink>
                            </NavItem>

                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: customActiveTab === "2",
                                    })}
                                    onClick={() => {
                                        toggleCustom("2")
                                    }}
                                >
                                    <span className="d-block d-sm-none">
                                        <i className="far fa-user"></i>
                                    </span>
                                    <span className="d-none d-sm-block">
                                        Completed With Error({fileCount?.errorFileCount})
                                    </span>
                                </NavLink>
                            </NavItem>

                        </Nav>
                        <TabContent
                            activeTab={customActiveTab}
                            className="p-3 text-muted"
                        >
                            <TabPane tabId="1">
                                <Row>
                                    <Col>
                                        <TableContainerV1
                                            columns={columns}
                                            data={userList}
                                            pagination={pagination}
                                            handlePageChange={handlePageChange}
                                            searchHelperText={"Search by Batch Id, Uploaded By, Dealer User"}
                                            handleSearchFilter={handleSearchFilter}
                                            sortOptions={sortingOptions}
                                            handleSortColumn={handleSortColumn}
                                            handleClearSearch={handleClearSearch}
                                            className="custom-header-css"
                                        />
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="2">
                                <Row>
                                    <Col>
                                        <TableContainerV1
                                            columns={columns}
                                            data={userList}
                                            pagination={pagination}
                                            handlePageChange={handlePageChange}
                                            handleSearchFilter={handleSearchFilter}
                                            searchHelperText={"Search by Batch Id, Uploaded By, Dealer User"}
                                            sortOptions={sortingOptions}
                                            handleSortColumn={handleSortColumn}
                                            handleClearSearch={handleClearSearch}
                                            className="custom-header-css"
                                        />
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

EmpBulkTargetTable.propTypes = {
    customers: PropTypes.array,
    onGetCustomers: PropTypes.func,
    onAddNewCustomer: PropTypes.func,
    onDeleteCustomer: PropTypes.func,
    onUpdateCustomer: PropTypes.func,
};

export default EmpBulkTargetTable;

const TableActionsComponent = (rowData) => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("user"));

    const navigateToViewRoles = (id) => {
        const encryptedId = btoa(id.toString());
        navigate(`/${user.roleName}/uploadbulkordertargetstatus?id=${encodeURIComponent(encryptedId)}`);
    };


    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-end">

                <DropdownItem
                    onClick={() => { navigateToViewRoles(rowData.id) }
                    }
                >
                    <i className="mdi mdi-eye font-size-16 text-success me-1" id="edittooltip"></i>
                    View
                    <UncontrolledTooltip placement="top" target="edittooltip">
                        View
                    </UncontrolledTooltip>
                </DropdownItem>

            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

function downloadExcelFile(path) {
    const url = process.env.REACT_APP_IMAGE_URL;
    const link = document.createElement("a");
    link.href = `${url}/${path}`;
    link.download = "Bulk_upload_user.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const TableFileComponent = (value, downloadExcelFile) => {
    if (value) {
        return <i className="mdi mdi-file-download-outline action-icon" onClick={() => { downloadExcelFile(value) }} onKeyUp={() => { }}></i>
    }
}